import { template as template_6a92331be0624b38918eba59a40b89b8 } from "@ember/template-compiler";
import Portal from 'ember-stargate/components/portal';
import { hash } from '@ember/helper';
import Component from '@glimmer/component';
import { registerDestructor } from '@ember/destroyable';
import { Modal } from 'bootstrap';
import { optional, withDefault } from '@eflexsystems/ember-composable-helpers';
import { on } from '@ember/modifier';
// eslint-disable-next-line ember/no-at-ember-render-modifiers
import didInsert from '@ember/render-modifiers/modifiers/did-insert';
import BsButton from 'eflex/components/bs-button';
import { t } from 'ember-intl';
import onKey from 'ember-keyboard/modifiers/on-key';
import FaIcon from '@fortawesome/ember-fontawesome/components/fa-icon';
class Base extends Component {
    noOp = (event, ekEvent)=>{
        event.stopPropagation();
        ekEvent.stopPropagation();
    };
    onDidInsert = (element)=>{
        const modal = new Modal(element);
        registerDestructor(this, ()=>{
            modal.hide();
            modal.dispose();
        });
        modal.show();
    };
    static{
        template_6a92331be0624b38918eba59a40b89b8(`
    <div
      class="modal"
      data-bs-focus={{withDefault @focus 'true'}}
      data-bs-keyboard={{withDefault @keyboard 'true'}}
      data-bs-backdrop="static"
      {{didInsert this.onDidInsert}}
      {{on 'hidden.bs.modal' (optional @onCancel)}}
      {{onKey
        '_all'
        this.noOp
        priority=999
      }}
      ...attributes
    >
      {{yield}}
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
const HeaderClose = template_6a92331be0624b38918eba59a40b89b8(`
<button
  class="btn-close d-flex align-items-center"
  type="button"
  data-bs-dismiss="modal"
  aria-label="close"
  ...attributes
>
  <FaIcon
    @icon="xmark"
    @prefix="fas"
    @size="lg"
    class={{if @darkMode "text-gray-100"}}
  />
</button>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
const Header = template_6a92331be0624b38918eba59a40b89b8(`
<div
  class="modal-header d-flex flex-column align-items-start border-0 {{if @darkMode "bg-gray-700"}}"
  ...attributes
>
  {{#if (has-block)}}
    {{yield (hash close=(component
      HeaderClose
      darkMode=@darkMode
    ))}}
  {{else}}
    <div class="d-flex align-items-center w-100">
      <h5 class="modal-title lh-sm">
        {{@text}}
      </h5>
      <HeaderClose
        class="shadow-none px-3 py-1 my-0"
        @darkMode={{@darkMode}}
      />
    </div>
    {{#if @subtext}}
      <p class="fw-semibold mb-0">{{@subtext}}</p>
    {{/if}}
  {{/if}}
</div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
const FooterConfirm = template_6a92331be0624b38918eba59a40b89b8(`
<BsButton
  @type={{withDefault @type 'primary'}}
  class="modal-confirm fs-3"
  @disabled={{@disabled}}
  @onClick={{@onConfirm}}
  ...attributes
>
  {{#if (has-block)}}
    {{yield}}
  {{else}}
    {{t "ok"}}
  {{/if}}
</BsButton>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
const FooterClose = template_6a92331be0624b38918eba59a40b89b8(`
<BsButton
  @type={{withDefault @type (if @darkMode 'outline-secondary' 'secondary')}}
  class="modal-close fs-3"
  data-bs-dismiss="modal"
  ...attributes
>
  {{#if (has-block)}}
    {{yield}}
  {{else}}
    {{t "cancel"}}
  {{/if}}
</BsButton>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
const Footer = template_6a92331be0624b38918eba59a40b89b8(`
<div
  class="modal-footer d-flex align-items-end flex-row-reverse justify-content-start p-4 {{if @darkMode "bg-gray-800"}}"
  ...attributes
>
  {{#if (has-block)}}
    {{yield
      (hash
        close=(component
          FooterClose
          darkMode=@darkMode
        )
        confirm=(component
          FooterConfirm
          onConfirm=@onConfirm
          disabled=@disabled
          darkMode=@darkMode
        )
      )
    }}
  {{else}}
    <FooterConfirm
      @onConfirm={{@onConfirm}}
      @disabled={{@disabled}}
      @darkMode={{@darkMode}}
    />
    {{#unless @confirmOnly}}
      <FooterClose
        @darkMode={{@darkMode}}
      />
    {{/unless}}
  {{/if}}
</div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
const Body = template_6a92331be0624b38918eba59a40b89b8(`
<div
  class="modal-body {{if @darkMode "bg-gray-800"}}"
  ...attributes
>
  {{yield}}
</div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default template_6a92331be0624b38918eba59a40b89b8(`
<Portal @target="modal">
  <Base
    class="standard-modal modal {{if @darkMode "text-white"}}"
    @onCancel={{@onCancel}}
    @focus={{@focus}}
    @keyboard={{@keyboard}}
    @darkMode={{@darkMode}}
    ...attributes
  >
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-{{@size}}">
      <div class="modal-content {{@contentClass}} {{if @darkMode "bg-gray-700 text-white"}}">
        {{#if (has-block)}}
          {{yield
            (hash
              header=(component
                Header
                darkMode=@darkMode
              )
              body=(component
                Body
                darkMode=@darkMode
              )
              footer=(component
                Footer
                onConfirm=@onConfirm
                disabled=@disabled
                darkMode=@darkMode
              )
            )
          }}
        {{else}}
          <Header
            @text={{@header}}
            @darkMode={{@darkMode}}
          />
          <Body
            @darkMode={{@darkMode}}
          >
            <p>
              {{@text}}
            </p>
          </Body>
          <Footer
            @onConfirm={{@onConfirm}}
            @confirmOnly={{@confirmOnly}}
            @disabled={{@disabled}}
            @darkMode={{@darkMode}}
          />
        {{/if}}
      </div>
    </div>
  </Base>
</Portal>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
